<template>
  <Modal
    :value="value"
    :hasFooter="true"
    width="auto"
    minWidth="961px"
    subtitle="Confira os dados que serão atualizados"
    class="modal-component"
    ref="modal"
    @modal-cancel="cancelModal"
  >
    <template #body-content>
      <div v-if="periods.length > 0" class="body-content">
        <!-- CABECALHO -->
        <div class="heading">
          <Heading class="heading__title" level="1">
            {{ hotel.nome }}
          </Heading>
          <Heading class="heading__subtitle" level="2">
            Valores atualizados
          </Heading>
        </div>
        <div class="period-box">
          <Paragraph class="period-box__heading" font-size="small">
            Períodos
          </Paragraph>
          <div class="period-box__list">
            <Chip
              v-for="(date, i) in periods"
              :key="`${date.start}-${date.end}-${i}`"
              class=""
            >
              {{ formatDate(date.rawStart, 'dd MMM yyyy') }} -
              {{ formatDate(date.rawEnd, 'dd MMM yyyy') }}
            </Chip>
          </div>
        </div>
        <div class="period-table">
          <CleanTable
            :columns="[
              { label: 'Dias da semana', value: 'week', tooltip: false },
              { label: 'Tipo', value: 'type', tooltip: false },
              { label: 'Valor', value: 'result', tooltip: false }
            ]"
            :rows="floatingData"
            :highlightCols="['result']"
          />
        </div>
      </div>

      <SeparateLine
        v-if="
          allotments.length > 0 ||
            vendasFechadasData.length > 0 ||
            minimoNoitesData.length > 0 ||
            ctaData.length > 0 ||
            ctdData.length > 0
        "
        :top="5"
        :bottom="5"
        :left="30"
        :right="30"
      />

      <div
        class="body-content"
        v-if="
          allotments.length > 0 ||
            vendasFechadasData.length > 0 ||
            minimoNoitesData.length > 0 ||
            ctaData.length > 0 ||
            ctdData.length > 0
        "
      >
        <!-- Disponibilidade Letsbook -->
        <div v-if="allotments.length > 0" class="mb-3">
          <Heading level="2" class="mb-3">
            Disponibilidade Let’s Book
          </Heading>
          <CleanTable
            :columns="[
              { label: 'Período', value: 'periodo', tooltip: false },
              { label: 'Dias da semana', value: 'dia', tooltip: false },
              { label: 'Quarto(s)', value: 'quartos', tooltip: false },
              {
                label: 'Disponibilidade (por dia)',
                value: 'disponibilidade',
                tooltip: false
              }
            ]"
            :rows="allotmentData"
            :highlightCols="['disponibilidade']"
          />
        </div>

        <!-- Fechar ou abrir vendas -->
        <div v-if="vendasFechadasData.length > 0" class="mb-3">
          <Heading level="2" class="mb-3">
            Fechar ou abrir vendas
          </Heading>
          <CleanTable
            :columns="[
              { label: 'Período', value: 'periodo', tooltip: false },
              { label: 'Dias da semana', value: 'dia', tooltip: false },
              { label: 'Quarto(s)', value: 'quartos', tooltip: false },
              { label: 'Tipo', value: 'vendas', tooltip: false }
            ]"
            :rows="vendasFechadasData"
            :highlightCols="['vendas']"
          />
        </div>

        <!-- Mínimo noites -->
        <div v-if="minimoNoitesData.length > 0" class="mb-3">
          <Heading level="2" class="mb-3">
            Mínimo de noites
          </Heading>

          <CleanTable
            :columns="[
              { label: 'Período', value: 'periodo', tooltip: false },
              { label: 'Dias da semana', value: 'dia', tooltip: false },
              { label: 'Quarto(s)', value: 'quartos', tooltip: false },
              { label: 'Tipo', value: 'tipoMinimoNoites', tooltip: false },
              {
                label: 'Número de noites',
                value: 'numeroNoites',
                tooltip: false
              }
            ]"
            :rows="minimoNoitesData"
            :highlightCols="['vendas']"
          />
        </div>

        <!-- CTA -->
        <div v-if="ctaData.length > 0" class="mb-3">
          <Heading level="2" class="mb-3">
            CTA
          </Heading>
          <CleanTable
            :columns="[
              { label: 'Período', value: 'periodo', tooltip: false },
              { label: 'Dias da semana', value: 'dia', tooltip: false },
              { label: 'Quarto(s)', value: 'quartos', tooltip: false }
            ]"
            :rows="ctaData"
          />
        </div>

        <!-- CTD -->
        <div v-if="ctdData.length > 0" class="mb-3">
          <Heading level="2" class="mb-3">
            CTD
          </Heading>
          <CleanTable
            :columns="[
              { label: 'Período', value: 'periodo', tooltip: false },
              { label: 'Dias da semana', value: 'dia', tooltip: false },
              { label: 'Quarto(s)', value: 'quartos', tooltip: false }
            ]"
            :rows="ctdData"
          />
        </div>
      </div>
    </template>

    <template #actions>
      <!-- CANCELAR -->
      <Button
        size="large"
        class="modal-component--content-button"
        layout="outline"
        @click="cancelModal"
        >Cancelar</Button
      >

      <!-- CONFIRMAÇÃO -->
      <Button
        size="large"
        class="modal-component--content-button"
        @click="confirmModal"
      >
        Confirmar
      </Button>
    </template>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseISO } from 'date-fns'
import Modal from '@/components/_base/patterns/Modal'
import Heading from '@/components/_base/elements/Heading'
import Chip from '@/components/_base/patterns/Chip'
import CleanTable from '@/components/_base/patterns/CleanTable'
import Paragraph from '@/components/_base/elements/Paragraph'
import SeparateLine from '@/components/_base/patterns/SeparateLine'
import Button from '@/components/_base/elements/Button'
import hotelRatesConfirmationModalMixin from '@/mixins/hotelRatesConfirmationModalMixin'

/**
 * Componente para apresentar a modal de confirmação da tarifa absoluta e suas restrições
 */
export default {
  name: 'ConfirmationModal',
  mixins: [hotelRatesConfirmationModalMixin],
  components: {
    Modal,
    Heading,
    Chip,
    CleanTable,
    Paragraph,
    SeparateLine,
    Button
  },
  props: {
    /** Controle de renderização da modal */
    value: {
      type: Boolean,
      default: false
    },
    selectedWeekDays: {
      type: Array,
      default: () => []
    },
    restrictions: {
      type: Object,
      default: () => {}
    },
    allotments: {
      type: Array,
      default: () => []
    },
    rooms: {
      type: Array,
      default: () => []
    },
    periods: {
      type: Array,
      default: () => []
    },
    /** Dados do hotel */
    hotel: {
      type: Object,
      default: () => {}
    },
    /**
     * Array de objetos das Tarifas Flutuantes (formatados para visualização)
     * @example [
     * {
     *    week: [],
     *    type: null,
     *    result: null,
     *  },
     * ]
     */
    floatingData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      allotmentData: [],
      ctdData: [],
      ctaData: [],
      vendasFechadasData: [],
      minimoNoitesData: [],
      weekdays: [
        { text: 'Domingo', value: 1 },
        { text: 'Segunda', value: 2 },
        { text: 'Terça', value: 3 },
        { text: 'Quarta', value: 4 },
        { text: 'Quinta', value: 5 },
        { text: 'Sexta', value: 6 },
        { text: 'Sábado', value: 7 }
      ]
    }
  },
  computed: {
    ...mapGetters('hotel', ['getCurrency'])
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          this.loadingData()
        }
      }
    }
  },
  methods: {
    cancelModal() {
      this.$emit('cancelModal')
      /** Fecha a modal */
      this.$emit('input', false)
    },
    confirmModal() {
      this.$emit('confirmModal')
      /** Fecha a modal */
      this.$emit('input', false)
    },
    loadingData() {
      /** Monta dados de allotment */
      if (this.allotments.length > 0) {
        this.allotmentData = this.allotments.map((restriction) => {
          const obj = {
            periodo: `${this.formatDate(
              parseISO(restriction.dataInicial),
              'dd MMM yyyy'
            )} - ${this.formatDate(
              parseISO(restriction.dataFinal),
              'dd MMM yyyy'
            )}`,
            dia: this.formatArrayToString(
              this.weekdays
                .filter((w) => restriction.diasSemana.includes(w.value))
                .flatMap((w) => w.text)
            ),
            quartos: restriction.quartos
              .map((item) => item.codigo)
              .reduce((acc, curr) => {
                const found = this.rooms.find((room) => room.codigo === curr)

                if (found) {
                  acc.push(found.nome)
                }

                return acc
              }, [])
              .join(', '),
            disponibilidade: restriction.quartos[0].allotment
          }

          return obj
        })
      }

      /** Monta dados de CTA para a modal de confirmação */
      if (this.restrictions) {
        this.ctaData = []
        if (this.restrictions.CTA) {
          this.ctaData = this.restrictions.CTA.map((restriction) => {
            const obj = {
              periodo: `${this.formatDate(
                parseISO(restriction.dataInicial),
                'dd MMM yyyy'
              )} - ${this.formatDate(
                parseISO(restriction.dataFinal),
                'dd MMM yyyy'
              )}`,
              dia: this.formatArrayToString(
                this.weekdays
                  .filter((w) => restriction.diasSemana.includes(w.value))
                  .flatMap((w) => w.text)
              ),
              quartos: this.getSelectedRoomNames(restriction)
            }

            return obj
          })
        }

        /** Monta dados de CTD para a modal de confirmação */
        this.ctdData = []
        if (this.restrictions.CTD) {
          this.ctdData = this.restrictions.CTD.map((restriction) => {
            const obj = {
              periodo: `${this.formatDate(
                parseISO(restriction.dataInicial),
                'dd MMM yyyy'
              )} - ${this.formatDate(
                parseISO(restriction.dataFinal),
                'dd MMM yyyy'
              )}`,
              dia: this.formatArrayToString(
                this.weekdays
                  .filter((w) => restriction.diasSemana.includes(w.value))
                  .flatMap((w) => w.text)
              ),
              quartos: this.getSelectedRoomNames(restriction)
            }

            return obj
          })
        }

        this.vendasFechadasData = []
        if (this.restrictions.vendasFechadas) {
          this.restrictions.vendasFechadas.forEach((restriction) => {
            this.vendasFechadasData.push({
              periodo: `${this.formatDate(
                parseISO(restriction.dataInicial),
                'dd MMM yyyy'
              )} - ${this.formatDate(
                parseISO(restriction.dataFinal),
                'dd MMM yyyy'
              )}`,
              vendas: restriction.vendasFechadas
                ? 'Vendas fechadas'
                : 'Vendas abertas',
              dia: this.formatArrayToString(
                this.weekdays
                  .filter((w) => restriction.diasSemana.includes(w.value))
                  .flatMap((w) => w.text)
              ),
              quartos: this.getSelectedRoomNames(restriction)
            })
          })
        }

        this.minimoNoitesData = []
        if (this.restrictions.minimoNoites) {
          this.restrictions.minimoNoites.forEach((restriction) => {
            this.minimoNoitesData.push({
              periodo: `${this.formatDate(
                parseISO(restriction.dataInicial),
                'dd MMM yyyy'
              )} - ${this.formatDate(
                parseISO(restriction.dataFinal),
                'dd MMM yyyy'
              )}`,
              dia: this.formatArrayToString(
                this.weekdays
                  .filter((w) => restriction.diasSemana.includes(w.value))
                  .flatMap((w) => w.text)
              ),
              tipoMinimoNoites:
                restriction.tipoMinimoNoites === 1
                  ? 'Chegando em'
                  : 'Passando por',
              numeroNoites: restriction.numeroNoites,
              quartos: this.getSelectedRoomNames(restriction)
            })
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.body-content {
  padding: 35px 35px 20px 35px;
}

.heading {
  margin-bottom: 20px;
  &__title {
    font-size: font-size('size-x-large');
    margin-bottom: 32px;
  }
}

.period-box {
  &__heading {
    color: $gray-dark;
    line-height: 21px;
  }
  &__list {
    margin-bottom: 12px;
    .chip {
      margin-right: -1px;
    }
  }
}

.period-table {
  .hasDiscount {
    ::v-deep .clean-table-body .clean-table-row-cell--td:last-of-type p {
      color: $error;
    }
  }
}
</style>
